import { render, staticRenderFns } from "./AvitoCitiesList.vue?vue&type=template&id=2f3baa91&"
import script from "./AvitoCitiesList.vue?vue&type=script&lang=js&"
export * from "./AvitoCitiesList.vue?vue&type=script&lang=js&"
import style0 from "./AvitoCitiesList.vue?vue&type=style&index=0&id=2f3baa91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports